import Queries from './quick-queries';
import { makeUrl } from './makeUrl';
import { getRecordedFeatureFlag } from 'app/src/quickload/getRecordedFeatureFlag';
// eslint-disable-next-line no-restricted-imports
import { isPossiblyValidOrgName } from '@trello/organizations/src/isPossiblyValidOrgName';

const shouldMergeBoardRequests = () =>
  getRecordedFeatureFlag(
    'fep.merge-board-quickload-requests',
    'false', // using strings to preserve the 'false' value in stored snapshot
  );

export const preloadUrlConfig: {
  pattern: RegExp;
  urls: (
    patternExecResult: RegExpExecArray,
  ) => [url: string, operationName: string][];
}[] = [
  // we've come directly to trello.com, so load the data for the member boards page
  {
    pattern: new RegExp(`^/$`),
    urls: () => {
      return [
        [
          makeUrl('/1/Members/me', Queries.memberBoards),
          'quick-queries:memberBoards',
        ],
      ];
    },
  },
  // we're performing a search using '//', but there was no search term
  {
    pattern: new RegExp(`^//$`),
    urls: () => {
      return [
        [
          makeUrl('/1/Members/me', Queries.memberQuickBoards),
          'quick-queries:memberQuickBoards',
        ],
      ];
    },
  },
  // we're performing a search using '//'
  {
    pattern: new RegExp(`^//([^/]*)`),
    urls: (patternExecResult: RegExpExecArray) => {
      const search = decodeURIComponent(patternExecResult[1])
        .toLowerCase()
        .replace(/[-_ ]+/g, ' ');
      return [
        [
          makeUrl('/1/Members/me', Queries.memberQuickBoards),
          'quick-queries:memberQuickBoards',
        ],
        [
          makeUrl('/1/search', Queries.quickBoardsSearch(search)),
          'quick-queries:quickBoardsSearch',
        ],
      ];
    },
  },
  // we're on a board route
  {
    pattern: new RegExp(`^/b/([^/]+)`),
    urls: (patternExecResult: RegExpExecArray) => {
      const idBoard = patternExecResult[1];
      return shouldMergeBoardRequests() === 'true'
        ? [
            [
              makeUrl(`/1/Boards/${idBoard}`, Queries.currentBoardFull),
              'quick-queries:currentBoardFull',
            ],
          ]
        : [
            [
              makeUrl(`/1/Boards/${idBoard}`, Queries.currentBoardMinimal),
              'quick-queries:currentBoardMinimal',
            ],
            [
              makeUrl(`/1/Boards/${idBoard}`, Queries.currentBoardSecondary),
              'quick-queries:currentBoardSecondary',
            ],
            [
              makeUrl(`/1/Boards/${idBoard}`, Queries.currentBoardPluginData),
              'quick-queries:currentBoardPluginData',
            ],
          ];
    },
  },
  // we're on the old school board route
  {
    pattern: new RegExp(`^/board/[^/]+/([^/]+)`),
    urls: (patternExecResult: RegExpExecArray) => {
      const idBoard = patternExecResult[1];
      return shouldMergeBoardRequests() === 'true'
        ? [
            [
              makeUrl(`/1/Boards/${idBoard}`, Queries.currentBoardFull),
              'quick-queries:currentBoardFull',
            ],
          ]
        : [
            [
              makeUrl(`/1/Boards/${idBoard}`, Queries.currentBoardMinimal),
              'quick-queries:currentBoardMinimal',
            ],
            [
              makeUrl(`/1/Boards/${idBoard}`, Queries.currentBoardSecondary),
              'quick-queries:currentBoardSecondary',
            ],
            [
              makeUrl(`/1/Boards/${idBoard}`, Queries.currentBoardPluginData),
              'quick-queries:currentBoardPluginData',
            ],
          ];
    },
  },
  // we're on the card route
  {
    pattern: new RegExp(`^/c/([^/]+)`),
    urls: (patternExecResult: RegExpExecArray) => {
      const idCard = patternExecResult[1];
      return [
        [makeUrl(`/1/Cards/${idCard}`, Queries.card), 'quick-queries:card'],
      ];
    },
  },
  // we might be on an organization
  {
    pattern: new RegExp(`^/([^/]+)$`),
    urls: (patternExecResult: RegExpExecArray) => {
      const orgName = patternExecResult[1];
      return isPossiblyValidOrgName(orgName)
        ? [
            [
              makeUrl(
                `/1/Organizations/${orgName}`,
                Queries.workspaceBoardsPageMinimal,
              ),
              'quick-queries:workspaceBoardsPageMinimal',
            ],
          ]
        : [];
    },
  },
];
